module.exports = __webpack_public_path__ + "static/media/vadim_Yarmak.592376c7.jpg";